import DB from "@/common/utils/db";
/**
 * @description 公众号认证授权接口
 */
export function authorize(query) {
    return DB({
        url: "v1/wechat/authorize",
        method: "get",
        params: query
    });
}

/**
 * @description 查询 JS-SDK所需配置信息
 */

export function createJsapiSignature(query) {
    return DB({
        url: "v1/wechat/createJsapiSignature",
        method: "get",
        params: query
    });
}